import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Pill segmented control; the selected segment is a raised white chip. */
export const SegmentedToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  height: 28,
  borderRadius: theme.shape.borderRadius,
  padding: 4,
  gap: 4,
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    borderRadius: theme.shape.borderRadius,
    margin: 0,
    padding: '4px 16px',
    textTransform: 'none',
    fontSize: '0.85rem',
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
    '&.Mui-selected': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightSemiBold,
      boxShadow: theme.customShadows.card,
      borderRadius: theme.shape.borderRadius,
      '&:hover': { backgroundColor: theme.palette.background.paper },
    },
    '&:not(.Mui-selected):hover': { backgroundColor: 'transparent' },
  },
}));
